import React from 'react'
import { Tab } from 'semantic-ui-react'
import STSList from './STSList';
import ValidasiSTS from './ValidasiSTS';

const panes = [
   { 
      menuItem: 'List STS', 
      render: () => <Tab.Pane attached={false}><STSList /></Tab.Pane> 
    },
    // { 
    //   menuItem: 'Validasi STS', 
    //   render: () => <Tab.Pane attached={false}><ValidasiSTS /></Tab.Pane> 
    // },
]

const STSIndex = () => (
  <Tab menu={{ pointing: true }} panes={panes} />
)

export default STSIndex;


// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_sts/STSIndex.js